export default "__VITE_ASSET__28c18660__"